/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PodNameRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PodNameRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return PodNameRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PodNameRegexQueryOperator>): PodNameRegexQueryOperator {
        let obj = Object.assign(new PodNameRegexQueryOperator(), model);
        PodNameRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PodNameRegexQueryOperator>): PodNameRegexQueryOperator {
        if (!model) return null;
        return PodNameRegexQueryOperator.newInstance(<PodNameRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PodNameRegexQueryOperator) {
        if (!obj) return;

        models.PodNameRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PodNameRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PodNameRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.pod_name_regex) {
            models.Regex.fixupPrototype(this.pod_name_regex);
        }
    }

    /**
     * Kubernetes Pod name by regex match
     */
    pod_name_regex: models.Regex;

}
